import favicon from '../assets/image/favicon.gif'
import loading from '../assets/image/loading.gif'
import logo from '../assets/image/logo.png'

import star from '../assets/image/star.svg'
import line from '../assets/image/line.svg'

import graphicChart1 from '../assets/image/graphic-chart/graphic-chart1.jpg'
import graphicChart2 from '../assets/image/graphic-chart/graphic-chart2.jpg'
import graphicChart3 from '../assets/image/graphic-chart/graphic-chart3.jpg'
import graphicChart4 from '../assets/image/graphic-chart/graphic-chart4.jpg'
import graphicChart5 from '../assets/image/graphic-chart/graphic-chart5.jpg'
import graphicChart6 from '../assets/image/graphic-chart/graphic-chart6.jpg'

import magazing1 from '../assets/image/magazing/magazing1.jpg'
import magazing2 from '../assets/image/magazing/magazing2.jpg'

import bookcover1 from '../assets/image/bookcover/bookcover1.jpg'
import bookcover2 from '../assets/image/bookcover/bookcover2.jpg'
import bookcover3 from '../assets/image/bookcover/bookcover3.jpg'
import bookcover4 from '../assets/image/bookcover/bookcover4.jpg'

import step1 from '../assets/image/service/scene1.gif'
import step2 from '../assets/image/service/scene2.gif'
import step3 from '../assets/image/service/scene3.gif'
import step4 from '../assets/image/service/scene4.gif'


import ai_backgroundEl from '../assets/image/profile_images/ai_backgroundEl.svg'
import ai_flower from '../assets/image/profile_images/ai_flower.svg'
import ai_leaf from '../assets/image/profile_images/ai_leaf.png'
import ai_portait from '../assets/image/profile_images/ai_portait.png'

import yuchen_backgroundEl from '../assets/image/profile_images/yuchen_backgroundEl.svg'
import yuchen_leaf from '../assets/image/profile_images/yuchen_leaf-front.png'
import yuchen_portait from '../assets/image/profile_images/yuchen_portait.png'



export default {
  favicon,
  loading,
  logo,
  star,
  line,
  graphicChart1,
  graphicChart2,
  graphicChart3,
  graphicChart4,
  graphicChart5,
  graphicChart6,
  magazing1,
  magazing2,
  bookcover1,
  bookcover2,
  bookcover3,
  bookcover4,
  step1,
  step2,
  step3,
  step4,
  ai_portait,
  ai_leaf,
  ai_flower,
  ai_backgroundEl,
  yuchen_portait,
  yuchen_leaf,
  yuchen_backgroundEl
};
